import { useEffect } from "react";

const ChatbaseEmbed = () => {
    useEffect(() => {
        // Avoid injecting twice
        if (document.getElementById("chatbase-script")) return;

        const script = document.createElement("script");
        script.id = "chatbase-script";

        script.innerHTML = `
      (function(){
        if(!window.chatbase||window.chatbase("getState")!=="initialized"){
          window.chatbase=(...arguments)=>{
            if(!window.chatbase.q){window.chatbase.q=[]}
            window.chatbase.q.push(arguments)
          };
          window.chatbase=new Proxy(window.chatbase,{
            get(target,prop){
              if(prop==="q"){return target.q}
              return(...args)=>target(prop,...args)
            }
          })
        }
        const onLoad=function(){
          const script=document.createElement("script");
          script.src="https://www.chatbase.co/embed.min.js";
          script.id="k3GJPtMfCCtoGiieamYKr"; // your Agent ID
          script.domain="www.chatbase.co";
          document.body.appendChild(script)
        };
        if(document.readyState==="complete"){onLoad()}
        else{window.addEventListener("load",onLoad)}
      })();
    `;
        document.body.appendChild(script);
    }, []);

    return null; // no UI needed, it just loads the script
};

export default ChatbaseEmbed;
